// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SummaryFields_checkbox__2UGs2","paragraph":"SummaryFields_paragraph__1h8_4","dataPrivacyNote":"SummaryFields_dataPrivacyNote__1DaqF"};